import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import vuetify from './plugins/vuetify'

// Use axios as default http client
import axios from 'axios'
Vue.prototype.$http = axios

Vue.config.productionTip = false

store.subscribe((mutation, state) => {
	// Store the state object as a JSON string
	localStorage.setItem('config', JSON.stringify(state.config));
});

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
